import { RouteRecordRaw } from 'vue-router'
import { IUserProfileService } from './IUserProfileService'
import { getChildSections } from '@core/pages/user-profile/route/index2'

export class DefaultUserProfileService implements IUserProfileService {
  retrieveChildSections (systemRole: string, router): RouteRecordRaw {
    return getChildSections(systemRole, router) as any
  }
}
